<template>
  <div class="row">
    <div class="col-lg-6 dp02 p-3"
         style="min-height: 900px">
      <h1>{{ $t('results.Upload') }}</h1>
      <vue2-dropzone id="dropzone"
                     :options="dropZoneOptions"
                     class="myInput"
                     style="height:93%" />
    </div>
    <div class="col-lg-6">
      <DataTable ref="table"
                 :data-model="'results'"
                 :display-name-singular="$t('entities.Results.Singular')"
                 :display-name-plural="$t('entities.Results.Plural')"
                 :permission-name="'Results'"
                 :allow-create="false"
                 :allow-delete="false"
                 :allow-edit="false"
                 :exclude-fields="['id', 'paired', 'unpairable', 'generated', 'toBeGenerated', 'exception']"
                 style="min-height: 900px">
        <template #cell(status)="row">
          <StatusDisplay :status="row.item.status" />
        </template>
      </DataTable>
    </div>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';
import StatusDisplay from '@components/admin/results/StatusDisplay';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    DataTable, StatusDisplay, vue2Dropzone
  },
  data() {
    return {
      cancelRefresh: false,
      dropZoneOptions: {
        url: `${process.env.VUE_APP_API_ENDPOINT}admin/results/upload`,
        thumbnailWidth: 150,
        maxFileSize: 150,
        uploadMultiple: true,
        parallelUploads: 10,
        paramName: () => 'Files',
        acceptedFiles: '.csv',
        headers: { Authorization: `Bearer ${localStorage.getItem('default_auth_token')}` },
        dictDefaultMessage: this.$t('results.DropFiles')
      }
    };
  },
  watch: {
  },
  mounted() {
    this.refresh();
  },
  beforeDestroy() {
    this.cancelRefresh = true;
  },
  methods: {
    refresh() {
      if (!this.cancelRefresh) {
        this.$refs.table.refresh();
        setTimeout(this.refresh, 3000);
      }
    }
  }
};
</script>
<style scoped></style>
